export const OrdersDataCSVTypes = {
  OrdersList: '注文一覧',
  OrderItemsList: '注文商品一覧',
};

export const OrdersDataDateTypes = {
  EstimatedPickupTime: '受け渡し日時',
};

export const OrdersDataDateTypesV2 = {
  OrderDateTime: '注文日時',
  EstimatedPickupTime: '受け渡し日時',
};
